module.exports = __webpack_public_path__ + "img/zamena.ceefb391.webp";